"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authWatcher = authWatcher;

var _effects = require("redux-saga/effects");

var actions = _interopRequireWildcard(require("./actions"));

var authActions = _interopRequireWildcard(require("../../auth/actions"));

var userActions = _interopRequireWildcard(require("../../user/actions"));

var errorActions = _interopRequireWildcard(require("../../error/actions"));

var localeActions = _interopRequireWildcard(require("../../locale/actions"));

var logisticsActions = _interopRequireWildcard(require("../../logistics/actions"));

var types = _interopRequireWildcard(require("./types"));

var _apiRequest = require("../api/apiRequest");

var _Utils = _interopRequireDefault(require("../../../utils/Utils"));

var _actions7 = require("../customTableViews/loadAll/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(authWorker),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(authWatcher);

function authWorker(action) {
  var dto, claims;
  return regeneratorRuntime.wrap(function authWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.put)(actions.start());

        case 3:
          _context.next = 5;
          return (0, _effects.call)(_apiRequest.apiRequest, "auth/login", "POST", {
            body: action.payload,
            auth: false
          });

        case 5:
          dto = _context.sent;
          _context.next = 8;
          return (0, _effects.put)(userActions.set(dto.user));

        case 8:
          _context.next = 10;
          return (0, _effects.put)(localeActions.saga(dto.user.locale));

        case 10:
          _context.next = 12;
          return (0, _effects.put)(authActions.auth(dto.auth));

        case 12:
          // Set logistics mode from tokens
          claims = _Utils["default"].parseJwt(dto.auth.accessToken);
          _context.next = 15;
          return (0, _effects.put)(logisticsActions.set(claims.logisticsMode, claims.servedPartners, claims.warehousesAvailable));

        case 15:
          _context.next = 17;
          return (0, _effects.put)((0, authActions.tokenTimeoutCheckerSaga)());

        case 17:
          _context.next = 19;
          return (0, _effects.put)((0, _actions7.saga)());

        case 19:
          _context.next = 21;
          return (0, _effects.put)(errorActions.resetError());

        case 21:
          _context.next = 23;
          return (0, _effects.put)(actions.success());

        case 23:
          _context.next = 32;
          break;

        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          _context.next = 30;
          return (0, _effects.put)(authActions.unauthorizeSaga());

        case 30:
          _context.next = 32;
          return (0, _effects.put)(actions.failure());

        case 32:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 25]]);
}

function authWatcher() {
  return regeneratorRuntime.wrap(function authWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, authWorker);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}